import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=30320f46&scoped=true"
import script from "@/views/Orders/Orders.ts?vue&type=script&lang=ts&external"
export * from "@/views/Orders/Orders.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Orders/orders.scss?vue&type=style&index=0&id=30320f46&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30320f46",
  null
  
)

export default component.exports